export class AppError extends Error {
  code: string
  details?: unknown
  timestamp: number
  originalError?: any

  constructor(message: string, code: string = 'UNKNOWN_ERROR', details?: unknown, originalError?: any) {
    super(message)
    this.name = 'AppError'
    this.code = code
    this.details = details
    this.timestamp = Date.now()
    this.originalError = originalError
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      code: this.code,
      details: this.details,
      timestamp: this.timestamp
    }
  }
}

export class ValidationError extends AppError {
  fields: Record<string, string[]>

  constructor(message: string, fields: Record<string, string[]>) {
    super(message, 'VALIDATION_ERROR', fields)
    this.name = 'ValidationError'
    this.fields = fields
  }
}

export class NetworkError extends AppError {
  constructor(message: string = '網路連線失敗') {
    super(message, 'NETWORK_ERROR')
    this.name = 'NetworkError'
  }
}

// 標準錯誤代碼常數
export const ERROR_CODES = {
  // 系統層級錯誤
  SUCCESS: 'SUCCESS',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
  NETWORK_ERROR: 'NETWORK_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  
  // 業務層級錯誤
  INSUFFICIENT_POINTS: 'INSUFFICIENT_POINTS',
  RESOURCE_EXISTS: 'RESOURCE_EXISTS',
  INVALID_STATUS_TRANSITION: 'INVALID_STATUS_TRANSITION',
  FILE_UPLOAD_FAILED: 'FILE_UPLOAD_FAILED',
  CONNECTION_TEST_FAILED: 'CONNECTION_TEST_FAILED',
} as const

export type ErrorCode = typeof ERROR_CODES[keyof typeof ERROR_CODES]
